export type ConfirmedHarmonisedStandard = {
  designation: string
  title?: string
}

export type HarmonisedStandardRecommendation = {
  designation: string
  title: string | null
  reason: string | null
}

export function parseConfirmedHarmonisedStandards(
  json: unknown | null
): ConfirmedHarmonisedStandard[] {
  if (!Array.isArray(json)) {
    return []
  }

  const parsed: ConfirmedHarmonisedStandard[] = []
  for (const entry of json) {
    if (typeof entry !== 'object' || entry == null) {
      continue
    }
    const designation =
      'designation' in entry && typeof entry.designation === 'string'
        ? entry.designation.trim()
        : ''
    if (designation.length === 0) {
      continue
    }
    const title =
      'title' in entry && typeof entry.title === 'string'
        ? entry.title.trim()
        : undefined
    parsed.push({
      designation,
      ...(title != null && title.length > 0 ? { title } : {}),
    })
  }
  return parsed
}

export function hasConfirmedHarmonisedStandards(json: unknown | null): boolean {
  return parseConfirmedHarmonisedStandards(json).length > 0
}
